import DataMapper from './DataMapper'
import StateRM from '../responsemodel/StateRM'
import State from '../../models/State'

export default class StateDataMapper extends DataMapper<StateRM, State> {
  map = (rm: StateRM) => new State(rm.name, rm.code, rm.gstCode)
}
